import React from 'react';

import styles from './TypeButton.module.css';

const typeButton = props => {
  if (props.audience === 'currently_unavailable') {
    return (
      <div className={styles.Button+" "+styles.Unavailable}>
        {props.children}
      </div>
    );
  }
  return (
    <button className={styles.Button} onClick={() => props.buttonHandler(props.typeId)}>
      {props.children}
    </button>
  );
}

export default typeButton;
